export enum Brand {
  AA = 'AA',
  AARP = 'AARP',
  ACE = 'ACE',
  DEC = 'DEC',
  HSP = 'HSP',
  IDS = 'IDS',
  INS = 'INS',
  MTG = 'MTG',
  QA = 'QA',
}
